<template>
  <div v-show="show" class="loader">
    <div class="loaderContainer">
      <div class="row">
        <div class="col-12 text-center">
          <!-- <img
            :src="require('@/assets/img/skillers_logo_2x_mini.png')"
            alt="loader_icon"
            class="img-fluid"
          /> -->
          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="loaderTitle">
            Szuper, hogy a Skillers-el tanulsz ma is!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean
  }
};
</script>
